module.exports = __webpack_public_path__ + "img/pdf_bg_results_1.931515b5.png";